@use '@/styles/tokens' as *;

.band {
  display: flex;
  justify-content: space-between;
  align-items: stretch;
  gap: var(--space-4);
  padding: var(--space-8) 28px;
  overflow: hidden;
  background-color: var(--surface-card);
  // Shared design-system detail-header wash (same asset as OrderDetailHeader).
  background-image: url(../../../assets/images/order-detail-header-bg.webp);
  background-repeat: no-repeat;
  background-size: cover;
  margin: -24px -24px 24px;
}

.left {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  min-width: 0;
  flex: 1 1 auto;
}

.back {
  display: inline-flex;
  margin-top: 4px;
  padding: 0;
  border: 0;
  background: none;
  cursor: pointer;
  color: var(--text-primary);
  border-radius: var(--radius-sm);

  &:focus-visible {
    outline: none;
    box-shadow: var(--focus-ring);
  }
}

.identity {
  display: flex;
  flex-direction: column;
  gap: var(--space-6);
  min-width: 0;
}

.heading {
  display: flex;
  flex-direction: column;
  gap: var(--space-2);
  min-width: 0;
}

.nameRow {
  display: flex;
  align-items: center;
  gap: var(--space-4);
  min-width: 0;
}

// A long name gives way before the status/id group does (ADO 121002).
.name {
  @include truncate;
  min-width: 0;
  margin: 0;
  font-family: $font-family-heading;
  font-size: $font-size-2xl;
  font-weight: var(--font-weight-medium);
  line-height: 1;
  letter-spacing: -0.48px;
  color: var(--text-primary);
}

.statusGroup {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  gap: var(--space-2);
}

.dealerChip {
  display: inline-flex;
  align-items: center;
  gap: var(--space-1);
  padding: 6px;
  flex-shrink: 0;
  white-space: nowrap;
  background: $color-brand-100;
  border: 1px solid $color-accent2-700;
  border-radius: $radius-pill;
  font-size: $font-size-md;
  line-height: 1;
  color: var(--text-primary);
}

.dealerInfo {
  display: inline-flex;
  cursor: help;
  color: $color-brand-800;
}

.id {
  white-space: nowrap;
  font-size: $font-size-md;
  color: var(--text-primary);
}

.contacts {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 30px;
}

.contact,
.orderCount {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: $font-size-md;
  color: var(--text-primary);

  svg {
    color: $color-neutral-700;
  }
}

.moreAddresses {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 24px;
  height: 24px;
  padding: 0 6px;
  margin-left: 2px;
  cursor: pointer;
  background: $color-brand-900;
  color: var(--text-inverse);
  border-radius: $radius-xl;
  font-size: $font-size-xs;
}

.right {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  justify-content: space-between;
  flex-shrink: 0;
}

.orderCount {
  // Stays on the contacts row when a Dealer header renders no overflow menu above it (119120).
  margin-top: auto;
}

.addressList {
  margin: 0;
  padding-left: var(--space-4);
}
